import { useQuery } from '@tanstack/react-query';

import { sdk } from '@/services';

const CourseService = sdk.getService('CourseService');

export const useSectionsByCourse = (coursesIds?: string[]) => {
  const { data, isLoading } = useQuery({
    queryKey: ['sections', coursesIds],
    queryFn: () => CourseService.getSectionsByCourse(coursesIds!),
    enabled: !!coursesIds && coursesIds.length > 0
  });

  return { courses: data, isLoading };
};
